(function ($) {

//TODO: I guess this is where the i18n needs to be reimplemented.  I'll look
//      into existing patterns for i18n in javascript but i think that mimicking
//      pythons gettext might be a reasonable approach.
    var I18N = {
        Errors: {
            Dzc: "Sorry, we don't support Deep Zoom Collections!",
            Dzi: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
            Xml: "Hmm, this doesn't appear to be a valid Deep Zoom Image.",
            ImageFormat: "Sorry, we don't support {0}-based Deep Zoom Images.",
            Security: "It looks like a security restriction stopped us from " +
                "loading this Deep Zoom Image.",
            Status: "This space unintentionally left blank ({0} {1}).",
            OpenFailed: "Unable to open {0}: {1}"
        },

        Tooltips: {
            FullPage: "Toggle full page",
            Home: "Go home",
            ZoomIn: "Zoom in",
            ZoomOut: "Zoom out",
            NextPage: "Next page",
            PreviousPage: "Previous page",
            RotateLeft: "Rotate left",
            RotateRight: "Rotate right",
            Flip: "Flip Horizontally",
            MoveLeft: "向左移",
            MoveUp: "向上移",
            MoveRight: "向右移",
            MoveBottom: "向下移动",
        }
    };

    $.extend($, /** @lends OpenSeadragon */{

        /**
         * @function
         * @param {String} property
         */
        getString: function (prop) {

            var props = prop.split('.'),
                string = null,
                args = arguments,
                container = I18N,
                i;

            for (i = 0; i < props.length - 1; i++) {
                // in case not a subproperty
                container = container[props[i]] || {};
            }
            string = container[props[i]];

            if (typeof (string) !== "string") {
                $.console.error("Untranslated source string:", prop);
                string = ""; // FIXME: this breaks gettext()-style convention, which would return source
            }

            return string.replace(/\{\d+\}/g, function (capture) {
                var i = parseInt(capture.match(/\d+/), 10) + 1;
                return i < args.length ?
                    args[i] :
                    "";
            });
        },

        /**
         * @function
         * @param {String} property
         * @param {*} value
         */
        setString: function (prop, value) {

            var props = prop.split('.'),
                container = I18N,
                i;

            for (i = 0; i < props.length - 1; i++) {
                if (!container[props[i]]) {
                    container[props[i]] = {};
                }
                container = container[props[i]];
            }

            container[props[i]] = value;
        }

    });

}(OpenSeadragon));
